const WIDTH_SP = 768;

(() => {

  // ローディング完了後に表示
  const showBody = () => {
    const body = document.querySelector('body');
    body.style.opacity = 1;
  };

  // 初期化処理
  const init = () => {
    // 各初期化関数の呼び出し
    initRetina();
    initSmoothScroll();
    initIsOn();
    doFade();
    slider();
    initMvSlide();
    fixedCtaVisibility();
    accordion();
    initGalleryScrollVideo();
  };

  // リサイズイベント処理
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      fixedCtaVisibility();
    }, 200);
  };

  // スクロールイベント処理
  let lastScrollTime = 0;
  const handleScroll = () => {
    const now = Date.now();
    if (now - lastScrollTime >= 100) {
      doFade();
      initIsOn();
      fixedCtaVisibility();
      lastScrollTime = now;
    }
  };

  // イベントリスナーの登録
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', showBody);
  window.addEventListener('resize', handleResize);
  document.addEventListener('scroll', handleScroll);
  
})();

// Retina対応
const initRetina = () => {
  if (window.devicePixelRatio >= 2) {
    document.querySelectorAll('.retina').forEach(img => {
      const retinaSrc = img.getAttribute('src').replace(/\.(?=(?:png|jpg|jpeg)$)/i, '@2x.');
      img.setAttribute('srcset', `${retinaSrc} 2x`);
    });
  }
};

// スムーススクロール
const initSmoothScroll = () => {
  document.querySelectorAll('a[href^="#"]').forEach(trigger => {
    trigger.addEventListener('click', e => {
      e.preventDefault();
      const targetId = trigger.getAttribute('href').replace('#', '');
      const targetElement = document.getElementById(targetId);
      if (targetElement) adjustScrollPosition(targetElement, 'smooth');
    });
  });
};

const adjustScrollPosition = (targetElement, behavior = 'smooth') => {
  const rect = targetElement.getBoundingClientRect().top;
  const offset = window.pageYOffset;
  const gap = document.getElementById('header')?.clientHeight || 0 + 80;
  const target = rect + offset - gap;

  window.scrollTo({ top: target, behavior });
};

// スクロールでis-onクラスを付与
const initIsOn = () => {
  document.querySelectorAll('.js-scroll').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;

    const isLoad = elem.dataset.load !== undefined;
    const dispPosition = offset - windowHeight;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('is-on');
    }
  });
};

// 要素のフェード
const doFade = () => {
  document.querySelectorAll('.js-fade-in').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;
    const delay = parseFloat(elem.dataset.delay) || 0;
    const isLoad = elem.dataset.load !== undefined;
    const positionPc = parseFloat(elem.dataset.positionPc) || 200;
    const positionSp = parseFloat(elem.dataset.positionSp) || 0;
    const position = document.body.clientWidth > WIDTH_SP ? positionPc : positionSp;
    const dispPosition = offset - windowHeight + position;
    const duration = parseFloat(elem.dataset.duration) || 1.5;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('js-scroll-in');
      elem.style.transitionDelay = `${delay}s`;
      elem.style.transitionDuration = `${duration}s`;
    }
  });
};

// MVスライド（重ねて表示、data-delayミリ秒ごとに active / prev を切り替え）
const initMvSlide = () => {
  const wrapper = document.querySelector('.mv-slide-wrapper');
  if (!wrapper) return;

  const slides = Array.from(wrapper.querySelectorAll('.mv-slide'));
  if (slides.length === 0) return;

  const delay = parseInt(wrapper.dataset.delay, 10) || 4000;

  const goNext = () => {
    const activeEl = wrapper.querySelector('.mv-slide--active');
    const prevEl = wrapper.querySelector('.mv-slide--prev');
    const activeIndex = activeEl ? slides.indexOf(activeEl) : 0;
    const nextIndex = (activeIndex + 1) % slides.length;
    const nextEl = slides[nextIndex];

    if (activeEl) {
      activeEl.classList.remove('mv-slide--active');
      activeEl.classList.add('mv-slide--prev');
    }
    if (prevEl) {
      prevEl.classList.remove('mv-slide--prev');
    }
    if (nextEl) {
      nextEl.classList.add('mv-slide--active');
    }
  };

  setInterval(goNext, delay);
};

// スライダー
const slider = () => {

  // slider-detail
  const detailSlider = new Swiper('.slider-detail', {
    slidesPerView: 1,
    spaceBetween: 10,
    freeMode: true,
    allowTouchMove: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    speed: 300,
    loop: false,
    navigation: {
      prevEl: '.slider-detail__prev',
      nextEl: '.slider-detail__next',
    },
  });

  // voice-slide
  const voiceSlider = new Swiper('.voice-slide', {
    slidesPerView: "auto",
    spaceBetween: 16,
    freeMode: true,
    allowTouchMove: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    speed: 300,
    loop: true,
    navigation: {
      prevEl: '.voice-slide__btn-prev',
      nextEl: '.voice-slide__btn-next',
    },
  });

}

// fixed-ctaのshow: aboutが見えたら付与（footerでは外さない）
const fixedCtaVisibility = () => {
  const about = document.querySelector('.about');
  const fixedCta = document.getElementById('fixed-cta');
  if (!about || !fixedCta) return;

  const aboutRect = about.getBoundingClientRect();
  const windowHeight = window.innerHeight;

  if (aboutRect.top < windowHeight) {
    fixedCta.classList.add('show');
  } else {
    fixedCta.classList.remove('show');
  }
};

// ギャラリースクロールをホバーで一時停止
const initGalleryScrollVideo = () => {
  const touchAreas = document.querySelectorAll('.js-touch');
  touchAreas.forEach((area) => {
    area.addEventListener('mouseenter', () => {
      area.classList.add('is-paused');
    });
    area.addEventListener('mouseleave', () => {
      area.classList.remove('is-paused');
    });
  });
};

// アコーディオン開閉
const accordion = () => {

  const moreBtn = Array.from(document.querySelectorAll('.faq__q'));

  moreBtn.forEach((item) => {
    item.addEventListener('click', function() {
      this.classList.toggle('is-on');
      const target = this.nextElementSibling;
      
      if (target.style.maxHeight) {
        target.style.maxHeight = null;
      } else {
        target.style.maxHeight = target.scrollHeight + 'px';
      }
    });
  });
}